import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {  Button, ListItemIcon, ListItemText, Menu, MenuItem, Fade, Divider } from '@mui/material';
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  Info as InfoIcon,
  BarChart as BarChartIcon,
  History as HistoryIcon,
  Delete as DeleteIcon,
  Refresh as RefreshIcon,
} from '@mui/icons-material';
import DeleteConfirmationDialog from './DeleteConfirmationDialog';
import RefreshConfirmationDialog from './RefreshConfirmationDialog';

export default function UploadActions(props) {

  const { upload_key, user_key } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openRefreshDialog, setOpenRefreshDialog] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDelete = () => {
    setAnchorEl(null);
    setOpenDeleteDialog(true);
  };
  const handleRefresh = () => {
    setAnchorEl(null);
    setOpenRefreshDialog(true);
  };

  return (
    <>
      <DeleteConfirmationDialog
        openDialog={openDeleteDialog}
        setOpenDialog={setOpenDeleteDialog}
        upload_key={upload_key}
        user_key={user_key}
      />
      <RefreshConfirmationDialog
        openDialog={openRefreshDialog}
        setOpenDialog={setOpenRefreshDialog}
        upload_key={upload_key}
        user_key={user_key}
      />
      <Button
        id="upload-action-button"
        aria-controls={open ? 'upload-action-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="outlined"
        disableElevation
        endIcon={<KeyboardArrowDownIcon />}
      >
        Actions
      </Button>
      <Menu
        id="upload-action-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'upload-action-button',
        }}
        TransitionComponent={Fade}
      >
        <MenuItem
          onClick={handleClose}
          component={Link}
          to={{
            pathname: `/lists/${upload_key}`,
            search: user_key && `user_key=${user_key}`,
          }}
        >
          <ListItemIcon>
            <InfoIcon color={"primary"}/>
          </ListItemIcon>
          <ListItemText>
            Details
          </ListItemText>
        </MenuItem>
        <MenuItem
          onClick={handleClose} 
          component={Link}
          to={{
            pathname: `/lists/${upload_key}/history`,
            search: user_key && `user_key=${user_key}`,
          }}
        >
          <ListItemIcon>
            <HistoryIcon color={"primary"} />
          </ListItemIcon>
          <ListItemText>
            History
          </ListItemText>
        </MenuItem>
        <MenuItem
          onClick={handleClose} 
          component={Link}
          to={{
            pathname: `/lists/${upload_key}/analytics`,
            search: user_key && `user_key=${user_key}`,
          }}
        >
          <ListItemIcon>
            <BarChartIcon color={"primary"} />
          </ListItemIcon>
          <ListItemText>
            Analytics
          </ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={handleRefresh}
        >
          <ListItemIcon>
            <RefreshIcon color={"warning"} />
          </ListItemIcon>
          <ListItemText>
            Refresh
          </ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={handleDelete}
        >
          <ListItemIcon>
            <DeleteIcon color={"error"} />
          </ListItemIcon>
          <ListItemText>
            Delete
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
